/**
 * Tracks the last pointer position so a window can grow out of the icon,
 * tile or taskbar button that launched it.
 */
let last = null;

if (typeof window !== "undefined") {
  window.addEventListener(
    "pointerdown",
    (e) => {
      last = { x: e.clientX, y: e.clientY };
    },
    true
  );
}

export const getLastPointer = () => last;
